import styled from 'styled-components';
import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';

export const Wrapper = styled(Grid)`
  background-color: ${({ theme }) => theme.color.noir};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => theme.x2spacePx}px
    ${({ theme }) => theme.x3spacePx}px;
  ${({ theme }) => theme.typography.xSmall};
  color: ${({ theme }) => theme.color.lightGray};

  ${media.mdDown`
    border-radius: 0;
  `}
`;
